export default {
  backendApi: "/api/",
  mediaPath: "/media/",
  apiKey: "drW3-Pd_8H-92mBw5kM",
  httpAuth: {
    user: "porpoise",
    pass: "12india9",
  },
  localStoreEnabled: true,

  thumbParams: {
    mode: 'resize',
    width: 640,
    height: 2560
  },

  imageStyles: {
    large: {
      crop: "fit",
      sizes: [
        {
          width: 640,
          height: 640,
          max: 640
        },
        {
          width: 1920,
          height: 1920,
          min: 641,
          default: true
        },
      ]
    }
  },
  settings: {
    test_mode: true,
    submissions_deadline: "2020:01:31 00:00:00",
    dates: {
      full: 'd MMMM yyyy',
    },
    payment_step: "complete",
    submission_show_statement: true,
    enable_equal_ops: true,
    show_birthdate: false,
    show_education: false,
    enabled_art_media: [
      "printmaking",
      "photography",
      "digital",
      "audio",
      "drawing",
      "performance",
      "installation",
      "sculpture",
      "painting",
      "moving_image",
      "site_specific",
      "proposal"
    ],
    default_country_code: "GB",
    enabled_video_sources: [
      "vimeo"
    ],
    enabled_image_sources: [
      "local"
    ],
    enabled_audio_sources: [
      "local"
    ],
    show_country_selector: false,
    enabled_graduate_statuses: [
      "final_year",
      "new_postgraduate",
      "postgraduate"
    ],
    payment_method: "paypal",
    submissions_open: true,
    max_works_per_submission: 5,
    max_files_per_submission: 5,
    max_files_per_work: 5,
    work_validation_rule: "media",
    submission_price: 10,
    submission_currency: 'GBP',
    paypal_client_id: 'Acl1Hps_J--kRjv2bB-qeoUKUyYZRTG0YfLJ-6assk7DrraALOXoAeKiv1TYT3E0l8J5ABhwkf2iAVSL',
    max_stored_file_size_mb: 20,
    audio_file_max_duration: 130
  },
  mainMenuItems: [
    {
      title: 'Submissions', to: '/submissions', access: 'admin', children: [
        { title: 'Emails', to: '/mail-list', access: 'admin' },
        { title: 'Mail Logs', to: '/mail-logs', access: 'admin' }
      ]
    },
    {
      title: 'Review', to: '/review', access: 'selector'
    },
    { title: 'Users', to: '/users', access: 'admin' },
    {
      title: 'Settings', to: '/settings', access: 'admin', children: [
        { title: 'Snippets', to: '/snippets', access: 'admin' },
        { title: 'Messages', to: '/messages', access: 'admin' },
        { title: 'Colleges', to: '/colleges', access: 'admin' },
        { title: 'Sign-up List', to: '/signup', access: 'admin' },
        { title: 'Uploads', to: '/uploads', access: 'admin' },
        { title: 'Exports', to: '/operations', access: 'admin' }
      ]
    },
    {
      title: 'Questions', to: '/questions', access: 'admin', children: [
        { title: 'Responses', to: '/responses', access: 'admin' }
      ]
    },
  ],
  footer: {
    title: "",
    subtitle: "",
    menuItems: [
    ],
    creditLinks: [
      { to: "https://www.platform-3.co.uk", content: "© 2021 Platform-3" }
    ]
  }
}
